module.exports = __webpack_public_path__ + "img/stock4.473ca129.png";